<template>
  <div class="c-table" ref="baidusettable">
    <el-table class="common-el-table-styles" v-loading="loading" :data="data" :height="height" border stripe>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'control'">
            <el-button type="text" size="small" @click="$emit('on-edit', scope.row)" style="margin: 0 20px">编辑</el-button>
            <Poptip confirm transfer title="您确认删除该配置吗？" @on-ok="$emit('on-del', scope.row)">
              <el-button type="text" size="small" class="c-control-margin">删除</el-button>
            </Poptip>
          </div>
          <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'addTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { timeout } from '@/common/js/utils'
export default {
  name: 'baidusettable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  position: relative;
  background-color: #fff;

  .c-control-margin {
    margin: 0;
    padding: 0 6px;
  }
}
</style>
